import React, { useState } from "react";
import AddTeacherForm from "./AddTeacherForm";
import TeacherList from "./TeacherList";
import ChangePasswordForm from "../../ChangePasswordForm/ChangePasswordForm";
import NewsForm from "../../NewsForm/NewsForm";
import NewsDisplay from "../../NewsForm/NewsDisplay";
import Sidebar from "../../SideBar/SideBar";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthContext";
import ContentHeader from "../ContentHeeader/ContentHeader";

function AdminPage() {
	const { logout } = useAuth();
	const navigate = useNavigate();
	const [activeForm, setActiveForm] = useState("Users");
	const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
	const [title, setTitle] = useState("Anställd information");
	const [dataChanged, setDataChanged] = useState(false);
	const handleLogout = async () => {
		await logout();
		navigate("/login");
	};

	const handleHamburgerToggle = () => {
		setIsHamburgerOpen(!isHamburgerOpen);
	};

	const renderActiveForm = () => {
		switch (activeForm) {
			case "add":
				return <AddTeacherForm setDataChanged = {setDataChanged}/>;
			case "Users":
				return <TeacherList setDataChanged = {setDataChanged} dataChanged ={dataChanged}/>;
			case "news":
				return <NewsForm setDataChanged = {setDataChanged}/>;
			case "newsDisplay":
				return <NewsDisplay />;
			case "changePassword":
				return <ChangePasswordForm showTeacherId={true} />;
			default:
				return <div>Ogiltig åtgärd vald</div>;
		}
	};

	return (
		<div className="admin-container container border mt-3 p-2">
			<Sidebar
				setActiveForm={setActiveForm}
				showLastThree={false}
				onLogout={handleLogout}
				onHamburgerToggle={handleHamburgerToggle}
				isHamburgerOpen={isHamburgerOpen}
				setIsHamburgerOpen={setIsHamburgerOpen}
				setTitle={setTitle}
			/>
			<div className="content container border p-0">
				<ContentHeader title={title} />
				<div className="p-4">{renderActiveForm()}</div>
			</div>
		</div>
	);
}

export default AdminPage;
